/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {JsonApiResource} from "@irian-ro/abstract-resource";
import {RoleWithRightsDto, RoleWithRightsVo} from "@irian-ro/auth-web-client";
import {map} from "rxjs/operators";
import {RoleCompanyTypeMeta} from "@well/domain";
import {RoleWithCompanyTypeService} from "../role-with-company-type.service";

@Injectable()
export class RoleConfigurationService{

  constructor(private roleWithCompanyTypeService: RoleWithCompanyTypeService) {
  }

  getRolesForCurrentOwnerByCompanyType(): Observable<RoleWithRightsVo[]> {
    return this.roleWithCompanyTypeService.findAll().pipe(
      map(res => this.extractDataFieldIfExists(res))
    );
  }

  updateRole(role: RoleWithRightsDto){
    return this.roleWithCompanyTypeService.update(role);
  }

  getEditedRoleDto(operation: string, resourceUuid = ''): Observable<JsonApiResource<RoleWithRightsDto, RoleCompanyTypeMeta>>{
    return this.roleWithCompanyTypeService.getEditedRoleDto(operation, resourceUuid);
  }

  saveRoleWithCompanyType(role: RoleWithRightsDto): Observable<JsonApiResource<RoleWithRightsDto, any>>{
    return this.roleWithCompanyTypeService.save(role);
  }

  private extractDataFieldIfExists(resource: any){
    if(resource.data === undefined){
      return resource;
    }
    return resource.data;
  }

}
